import { render } from "./sel-panel.vue?vue&type=template&id=52820d27&scoped=true"
import script from "./sel-panel.vue?vue&type=script&lang=js"
export * from "./sel-panel.vue?vue&type=script&lang=js"

import "./sel-panel.vue?vue&type=style&index=0&id=52820d27&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52820d27"]])

export default __exports__